<template>
    <section class="landing landingbb purchase-sale">
        <div class="overlay">
            <div class="container">
                <div class="landing-content subpage-heading-center">
                    <span class="mini-title">{{ $t('autopurchaseform.labels.autoSaleForm-miniTitle') }} </span>
                    <span class="heading-title">{{ $t('autopurchaseform.labels.sale-auto-title') }} </span>
                    <hr>
                    <span class="paragraph">{{ $t('autopurchaseform.labels.sub-title-sale') }}</span>
                </div>
            </div>
        </div>
    </section>
    <div class="market-form">
        <div class="container">
            <form @submit.prevent="handleSubmit">
                <div class="form-grid">
                    <!-- Personal Details -->
                    <div class="input-container">
                        <label for="vorname">{{ $t('autopurchaseform.labels.vorname') }}</label>
                        <input type="text" id="vorname" name="vorname" v-model="formData.vorname"
                            @input="validateField('vorname')">
                        <p class="error-message" v-if="errors.vorname">{{ errors.vorname }}</p>
                    </div>
                    <div class="input-container">
                        <label for="nachname">{{ $t('autopurchaseform.labels.nachname') }}</label>
                        <input type="text" id="nachname" name="nachname" v-model="formData.nachname"
                            @input="validateField('nachname')">
                        <p class="error-message" v-if="errors.nachname">{{ errors.nachname }}</p>
                    </div>
                    <div class="input-container">
                        <label for="email">{{ $t('autopurchaseform.labels.email') }}</label>
                        <input type="email" id="email" name="email" v-model="formData.email"
                            @input="validateField('email')">
                        <p class="error-message" v-if="errors.email">{{ errors.email }}</p>
                    </div>
                    <div class="input-container">
                        <label for="strasse">{{ $t('autopurchaseform.labels.strasse') }}</label>
                        <input type="text" id="strasse" name="strasse" v-model="formData.strasse"
                            @input="validateField('strasse')">
                        <p class="error-message" v-if="errors.strasse">{{ errors.strasse }}</p>
                    </div>
                    <div class="input-container">
                        <label for="telefon1">{{ $t('autopurchaseform.labels.telefon1') }}</label>
                        <input type="text" id="telefon1" name="telefon1" v-model="formData.telefon1"
                            @input="validateField('telefon1')">
                        <p class="error-message" v-if="errors.telefon1">{{ errors.telefon1 }}</p>
                    </div>
                    <div class="input-container">
                        <label for="telefon2">{{ $t('autopurchaseform.labels.telefon2') }}</label>
                        <input type="text" id="telefon2" name="telefon2" v-model="formData.telefon2"
                            @input="validateField('telefon2')">
                        <p class="error-message" v-if="errors.telefon2">{{ errors.telefon2 }}</p>
                    </div>
                    <div class="input-container">
                        <label for="marke">{{ $t('autopurchaseform.labels.marke') }}</label>
                        <input type="text" id="marke" name="marke" v-model="formData.marke"
                            @input="validateField('marke')">
                        <p class="error-message" v-if="errors.marke">{{ errors.marke }}</p>
                    </div>
                    <div class="input-container">
                        <label for="plz">{{ $t('autopurchaseform.labels.plz') }}</label>
                        <input type="text" id="plz" name="plz" v-model="formData.plz" @input="validateField('plz')">
                        <p class="error-message" v-if="errors.plz">{{ errors.plz }}</p>
                    </div>
                    <div class="input-container">
                        <label for="fahrzeugtyp">{{ $t('autopurchaseform.labels.fahrzeugtyp') }}</label>
                        <input type="text" id="fahrzeugtyp" name="fahrzeugtyp" v-model="formData.fahrzeugtyp"
                            @input="validateField('fahrzeugtyp')">
                        <p class="error-message" v-if="errors.fahrzeugtyp">{{ errors.fahrzeugtyp }}</p>
                    </div>
                    <div class="input-container">
                        <label for="modell">{{ $t('autopurchaseform.labels.modell') }}</label>
                        <input type="text" id="modell" name="modell" v-model="formData.modell"
                            @input="validateField('modell')">
                        <p class="error-message" v-if="errors.modell">{{ errors.modell }}</p>
                    </div>
                    <div class="input-container">
                        <label for="getriebeart">{{ $t('autopurchaseform.labels.getriebeart') }}</label>
                        <input type="text" id="getriebeart" name="getriebeart" v-model="formData.getriebeart"
                            @input="validateField('getriebeart')">
                        <p class="error-message" v-if="errors.getriebeart">{{ errors.getriebeart }}</p>
                    </div>
                    <div class="input-container">
                        <label for="kraftstoff">{{ $t('autopurchaseform.labels.kraftstoff') }}</label>
                        <input type="text" id="kraftstoff" name="kraftstoff" v-model="formData.kraftstoff"
                            @input="validateField('kraftstoff')">
                        <p class="error-message" v-if="errors.kraftstoff">{{ errors.kraftstoff }}</p>
                    </div>
                    <div class="input-container">
                        <label for="leistungps">{{ $t('autopurchaseform.labels.leistungps') }}</label>
                        <input type="number" id="leistungps" name="leistungps" v-model="formData.leistungps"
                            @input="validateField('leistungps')">
                        <p class="error-message" v-if="errors.leistungps">{{ errors.leistungps }}</p>
                    </div>
                    <div class="input-container">
                        <label for="letzte-mfk">{{ $t('autopurchaseform.labels.letzte_mfk') }}</label>
                        <input type="date" id="letzte-mfk" name="letzte-mfk" v-model="formData.letzte_mfk"
                            @input="validateField('letzte_mfk')">
                        <p class="error-message" v-if="errors.letzte_mfk">{{ errors.letzte_mfk }}</p>
                    </div>
                    <div class="input-container">
                        <label for="erstzulassung">{{ $t('autopurchaseform.labels.erstzulassung') }}</label>
                        <input type="date" id="erstzulassung" name="erstzulassung" v-model="formData.erstzulassung"
                            @input="validateField('erstzulassung')">
                        <p class="error-message" v-if="errors.erstzulassung">{{ errors.erstzulassung }}</p>
                    </div>
                    <div class="input-container">
                        <label for="kilometerstand">{{ $t('autopurchaseform.labels.kilometerstand') }}</label>
                        <input type="number" id="kilometerstand" name="kilometerstand" v-model="formData.kilometerstand"
                            @input="validateField('kilometerstand')">
                        <p class="error-message" v-if="errors.kilometerstand">{{ errors.kilometerstand }}</p>
                    </div>
                    <div class="input-container">
                        <label for="tueren">{{ $t('autopurchaseform.labels.tueren') }}</label>
                        <input type="number" id="tueren" name="tueren" v-model="formData.tueren"
                            @input="validateField('tueren')">
                        <p class="error-message" v-if="errors.tueren">{{ errors.tueren }}</p>
                    </div>
                    <div class="input-container">
                        <label for="farbe">{{ $t('autopurchaseform.labels.farbe') }}</label>
                        <input type="text" id="farbe" name="farbe" v-model="formData.farbe"
                            @input="validateField('farbe')">
                        <p class="error-message" v-if="errors.farbe">{{ errors.farbe }}</p>
                    </div>
                    <div class="input-container">
                        <label for="hubraum">{{ $t('autopurchaseform.labels.hubraum') }}</label>
                        <input type="number" id="hubraum" name="hubraum" v-model="formData.hubraum"
                            @input="validateField('hubraum')">
                        <p class="error-message" v-if="errors.hubraum">{{ errors.hubraum }}</p>
                    </div>
                    <div class="input-container">
                        <label for="preis">{{ $t('autopurchaseform.labels.preis') }}</label>
                        <input type="number" id="preis" name="preis" v-model="formData.preis"
                            @input="validateField('preis')">
                        <p class="error-message" v-if="errors.preis">{{ errors.preis }}</p>
                    </div>
                    <div class="input-container">
                        <label for="jahrgang">{{ $t('autopurchaseform.labels.jahrgang') }}</label>
                        <input type="number" id="jahrgang" name="jahrgang" v-model="formData.jahrgang"
                            @input="validateField('jahrgang')">
                        <p class="error-message" v-if="errors.jahrgang">{{ errors.jahrgang }}</p>
                    </div>

                    <!-- Auto Config -->
                    <div class="input-container auto-config">
                        <label>{{ $t('autopurchaseform.labels.ausstattungen') }}</label>
                        <p class="error-message" v-if="errors.ausstattungen">{{ errors.ausstattungen }}</p>
                        <div class="checkbox-group">
                            <!-- First Column -->
                            <div class="property-items-column">
                                <div class="property-item">
                                    <input type="checkbox" id="abs" name="ausstattung" value="ABS"
                                        :checked="formData.ausstattung.includes('ABS')"
                                        @change="handleCheckboxChange($event, 'ABS')" />
                                    <label for="abs">{{ $t('autopurchaseform.labels.abs') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="4wd" name="ausstattung" value="4WD"
                                        :checked="formData.ausstattung.includes('4WD')"
                                        @change="handleCheckboxChange($event, '4WD')" />
                                    <label for="4wd">{{ $t('autopurchaseform.labels.4wd') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="sperrdifferential" name="ausstattung"
                                        value="Sperrdifferential"
                                        :checked="formData.ausstattung.includes('Sperrdifferential')"
                                        @change="handleCheckboxChange($event, 'Sperrdifferential')" />
                                    <label for="sperrdifferential">{{ $t('autopurchaseform.labels.sperrdifferential')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="tiefergelegt" name="ausstattung" value="tiefergelegt"
                                        :checked="formData.ausstattung.includes('tiefergelegt')"
                                        @change="handleCheckboxChange($event, 'tiefergelegt')" />
                                    <label for="tiefergelegt">{{ $t('autopurchaseform.labels.tiefergelegt') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="klimaanlage" name="ausstattung" value="Klimaanlage"
                                        :checked="formData.ausstattung.includes('Klimaanlage')"
                                        @change="handleCheckboxChange($event, 'Klimaanlage')" />
                                    <label for="klimaanlage">{{ $t('autopurchaseform.labels.klimaanlage') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="klimaautomatik" name="ausstattung" value="Klimaautomatik"
                                        :checked="formData.ausstattung.includes('Klimaautomatik')"
                                        @change="handleCheckboxChange($event, 'Klimaautomatik')" />
                                    <label for="klimaautomatik">{{ $t('autopurchaseform.labels.klimaautomatik')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="tempomat" name="ausstattung" value="Tempomat"
                                        :checked="formData.ausstattung.includes('Tempomat')"
                                        @change="handleCheckboxChange($event, 'Tempomat')" />
                                    <label for="tempomat">{{ $t('autopurchaseform.labels.tempomat') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="zentralveriegelung" name="ausstattung"
                                        value="Zentralveriegelung"
                                        :checked="formData.ausstattung.includes('Zentralveriegelung')"
                                        @change="handleCheckboxChange($event, 'Zentralveriegelung')" />
                                    <label for="zentralveriegelung">{{ $t('autopurchaseform.labels.zentralveriegelung')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="zv-m-fernbedienung" name="ausstattung"
                                        value="ZV_m._Fernbedienung"
                                        :checked="formData.ausstattung.includes('ZV_m_Fernbedienung')"
                                        @change="handleCheckboxChange($event, 'ZV_m_Fernbedienung')" />
                                    <label for="zv-m-fernbedienung">{{ $t('autopurchaseform.labels.zv_m_fernbedienung')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="alarmanlage" name="ausstattung" value="Alarmanlage"
                                        :checked="formData.ausstattung.includes('Alarmanlage')"
                                        @change="handleCheckboxChange($event, 'Alarmanlage')" />
                                    <label for="alarmanlage">{{ $t('autopurchaseform.labels.alarmanlage') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="servolenkung" name="ausstattung" value="Servolenkung"
                                        :checked="formData.ausstattung.includes('Servolenkung')"
                                        @change="handleCheckboxChange($event, 'Servolenkung')" />
                                    <label for="servolenkung">{{ $t('autopurchaseform.labels.servolenkung') }}</label>
                                </div>
                            </div>

                            <!-- Second Column -->
                            <div class="property-items-column">
                                <div class="property-item">
                                    <input type="checkbox" id="el-fensterheber-vorn" name="ausstattung"
                                        value="el_Fensterheber_vorn"
                                        :checked="formData.ausstattung.includes('el_Fensterheber_vorn')"
                                        @change="handleCheckboxChange($event, 'el_Fensterheber_vorn')" />
                                    <label for="el-fensterheber-vorn">{{
                                        $t('autopurchaseform.labels.el_fensterheber_vorn') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="el-fensterheber-hinten" name="ausstattung"
                                        value="el_Fensterheber_hinten"
                                        :checked="formData.ausstattung.includes('el_Fensterheber_hinten')"
                                        @change="handleCheckboxChange($event, 'el_Fensterheber_hinten')" />
                                    <label for="el-fensterheber-hinten">{{
                                        $t('autopurchaseform.labels.el_fensterheber_hinten') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="wegfahrsperre" name="ausstattung" value="Wegfahrsperre"
                                        :checked="formData.ausstattung.includes('Wegfahrsperre')"
                                        @change="handleCheckboxChange($event, 'Wegfahrsperre')" />
                                    <label for="wegfahrsperre">{{ $t('autopurchaseform.labels.wegfahrsperre') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="sitzmemory" name="ausstattung" value="Sitzmemory"
                                        :checked="formData.ausstattung.includes('Sitzmemory')"
                                        @change="handleCheckboxChange($event, 'Sitzmemory')" />
                                    <label for="sitzmemory">{{ $t('autopurchaseform.labels.sitzmemory') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="sportsitze" name="ausstattung" value="Sportsitze"
                                        :checked="formData.ausstattung.includes('Sportsitze')"
                                        @change="handleCheckboxChange($event, 'Sportsitze')" />
                                    <label for="sportsitze">{{ $t('autopurchaseform.labels.sportsitze') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="sitzheizung-vorne" name="ausstattung"
                                        value="Sitzheizung_vorne"
                                        :checked="formData.ausstattung.includes('Sitzheizung_vorne')"
                                        @change="handleCheckboxChange($event, 'Sitzheizung_vorne')" />
                                    <label for="sitzheizung-vorne">{{ $t('autopurchaseform.labels.sitzheizung_vorne')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="sitzheizung-hinten" name="ausstattung"
                                        value="Sitzheizung_hinten"
                                        :checked="formData.ausstattung.includes('Sitzheizung_hinten')"
                                        @change="handleCheckboxChange($event, 'Sitzheizung_hinten')" />
                                    <label for="sitzheizung-hinten">{{ $t('autopurchaseform.labels.sitzheizung_hinten')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="standheizung" name="ausstattung" value="Standheizung"
                                        :checked="formData.ausstattung.includes('Standheizung')"
                                        @change="handleCheckboxChange($event, 'Standheizung')" />
                                    <label for="standheizung">{{ $t('autopurchaseform.labels.standheizung') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="led" name="ausstattung"
                                        value="LED"
                                        :checked="formData.ausstattung.includes('LED')"
                                        @change="handleCheckboxChange($event, 'LED')" />
                                    <label for="LED">{{ $t('autopurchaseform.labels.LED')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="navigationssystem" name="ausstattung"
                                        value="Navigationssystem"
                                        :checked="formData.ausstattung.includes('Navigationssystem')"
                                        @change="handleCheckboxChange($event, 'Navigationssystem')" />
                                    <label for="navigationssystem">{{ $t('autopurchaseform.labels.navigationssystem')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="bordcomputer" name="ausstattung" value="Bordcomputer"
                                        :checked="formData.ausstattung.includes('Bordcomputer')"
                                        @change="handleCheckboxChange($event, 'Bordcomputer')" />
                                    <label for="bordcomputer">{{ $t('autopurchaseform.labels.bordcomputer') }}</label>
                                </div>
                            </div>

                            <!-- Third Column -->
                            <div class="property-items-column">
                                <div class="property-item">
                                    <input type="checkbox" id="nebelscheinwerfer-vorne" name="ausstattung"
                                        value="Nebelscheinwerfer_vorne"
                                        :checked="formData.ausstattung.includes('Nebelscheinwerfer_vorne')"
                                        @change="handleCheckboxChange($event, 'Nebelscheinwerfer_vorne')" />
                                    <label for="nebelscheinwerfer-vorne">{{
                                        $t('autopurchaseform.labels.nebelscheinwerfer_vorne') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="winterpneu" name="ausstattung" value="Winterpneu"
                                        :checked="formData.ausstattung.includes('Winterpneu')"
                                        @change="handleCheckboxChange($event, 'Winterpneu')" />
                                    <label for="winterpneu">{{ $t('autopurchaseform.labels.winterpneu') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="alufelgen" name="ausstattung" value="Alufelgen"
                                        :checked="formData.ausstattung.includes('Alufelgen')"
                                        @change="handleCheckboxChange($event, 'Alufelgen')" />
                                    <label for="alufelgen">{{ $t('autopurchaseform.labels.alufelgen') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="sommerpneu" name="ausstattung" value="Sommerpneu"
                                        :checked="formData.ausstattung.includes('Sommerpneu')"
                                        @change="handleCheckboxChange($event, 'Sommerpneu')" />
                                    <label for="sommerpneu">{{ $t('autopurchaseform.labels.sommerpneu') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="stahlfelgen" name="ausstattung" value="Stahlfelgen"
                                        :checked="formData.ausstattung.includes('Stahlfelgen')"
                                        @change="handleCheckboxChange($event, 'Stahlfelgen')" />
                                    <label for="stahlfelgen">{{ $t('autopurchaseform.labels.stahlfelgen') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="ganzjahrespneu" name="ausstattung" value="Ganzjahrespneu"
                                        :checked="formData.ausstattung.includes('Ganzjahrespneu')"
                                        @change="handleCheckboxChange($event, 'Ganzjahrespneu')" />
                                    <label for="ganzjahrespneu">{{ $t('autopurchaseform.labels.ganzjahrespneu')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="el-verstellbarer-sitz-fahrer" name="ausstattung"
                                        value="el_verstellb_Sitz_Fahrer"
                                        :checked="formData.ausstattung.includes('el_verstellb_Sitz_Fahrer')"
                                        @change="handleCheckboxChange($event, 'el_verstellb_Sitz_Fahrer')" />
                                    <label for="el-verstellbarer-sitz-fahrer">{{
                                        $t('autopurchaseform.labels.el_verstellbarer_sitz_fahrer') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="beifahrer" name="ausstattung" value="Beifahrer"
                                        :checked="formData.ausstattung.includes('Beifahrer')"
                                        @change="handleCheckboxChange($event, 'Beifahrer')" />
                                    <label for="beifahrer">{{ $t('autopurchaseform.labels.beifahrer') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="airbag-fahrer" name="ausstattung" value="Airbag Fahrer"
                                        :checked="formData.ausstattung.includes('Airbag_Fahrer')"
                                        @change="handleCheckboxChange($event, 'Airbag_Fahrer')" />
                                    <label for="airbag-fahrer">{{ $t('autopurchaseform.labels.airbag_fahrer') }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="airbag-beifahrer" name="ausstattung"
                                        value="Airbag_Beifahrer"
                                        :checked="formData.ausstattung.includes('Airbag_Beifahrer')"
                                        @change="handleCheckboxChange($event, 'Airbag_Beifahrer')" />
                                    <label for="airbag-beifahrer">{{ $t('autopurchaseform.labels.airbag_beifahrer')
                                        }}</label>
                                </div>
                                <div class="property-item">
                                    <input type="checkbox" id="sideairbags" name="ausstattung" value="Sideairbags"
                                        :checked="formData.ausstattung.includes('Sideairbags')"
                                        @change="handleCheckboxChange($event, 'Sideairbags')" />
                                    <label for="sideairbags">{{ $t('autopurchaseform.labels.sideairbags') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Bemerkungen -->
                    <div class="textarea-container">
                        <label for="bemerkungen">{{ $t('autopurchaseform.labels.bemerkungen') }}</label>
                        <textarea id="bemerkungen" name="bemerkungen" v-model="formData.bemerkungen"
                            @input="validateField('bemerkungen')"></textarea>
                        <p class="error-message" v-if="errors.bemerkungen">{{ errors.bemerkungen }}</p>
                    </div>

                    <div class="input-container">
                        <label for="fotos">{{ $t('autopurchaseform.labels.fotos') }}</label>

                        <!-- Image List (Each Image in a Row) -->
                        <div class="file-upload-list">
                            <div v-for="(fileInput, index) in fileInputs" :key="index" class="file-upload-wrapper">

                                <!-- Hidden file input -->
                                <input type="file" :id="'fotos-' + index" name="fotos[]" accept="image/*" multiple
                                    @change="handleFileUpload($event, index)" class="hidden-file-input"
                                    ref="fileInputRefs" />

                                <!-- Image Box (80% width) -->
                                <div class="image-box" @click="triggerFileInput(index)">
                                    <span v-if="selectedFiles[index]?.length" class="file-name">
                                        {{ selectedFiles[index][0].name }}
                                    </span>
                                    <span v-else class="plus-icon">+</span>
                                </div>

                                <!-- Remove Button (20% width, only if a file is uploaded) -->
                                <div v-if="selectedFiles[index]?.length" class="remove-box">
                                    <button type="button" class="remove-btn" @click="removeFileInput(index)">
                                        ✖
                                    </button>
                                </div>

                            </div>
                        </div>
                        <p class="error-message" v-if="errors.fotos">{{ errors.fotos }}</p>
                    </div>

                    <!-- Signature -->
                    <div class="input-container">
                        <label for="unterschrift">{{ $t('autopurchaseform.labels.unterschrift') }}</label>
                        <input type="text" id="unterschrift" name="unterschrift"
                            placeholder="Vorname und Name (digitale Unterschrift)" v-model="formData.unterschrift"
                            @input="validateField('unterschrift')">
                        <p class="error-message" v-if="errors.unterschrift">{{ errors.unterschrift }}</p>
                    </div>

                    <!-- Submit -->
                    <button type="submit">{{ $t('autopurchaseform.labels.submit') }}</button>
                </div>
            </form>

        </div>
    </div>

</template>




<script>
import axios from "axios";
import API_BASE_URL from "@/config";

export default {
    name: "AutoPurchaseForm",
    data() {
        return {
            formData: {
                vorname: "",
                nachname: "",
                email: "",
                telefon1: "",
                telefon2: "",
                marke: "",
                plz: "",
                fahrzeugtyp: "",
                modell: "",
                getriebeart: "",
                kraftstoff: "",
                leistungps: "",
                erstzulassung: "",
                kilometerstand: "",
                tueren: "",
                farbe: "",
                preis: "",
                unterschrift: "",
                bemerkungen: "",
                fotos: [],
                ausstattung: [],
                jahrgang: "",
                strasse: "",
            },
            errors: {},
            fileInputs: [{}],
            selectedFiles: [],
            maxFields: 15, // Stores real-time validation errors
            // Default language, you can set dynamically
        };

    },
    methods: {
        async handleFileUpload(event, index) {
            const files = Array.from(event.target.files);
            if (files.length === 0) return;

            console.log("📸 Files selected:", files.map(f => f.name));

            try {
                if (!this.formData.fotos) {
                    this.formData.fotos = [];
                }

                const formData = new FormData();
                formData.append("field", "fotos");
                formData.append("lang", this.$i18n.locale);

                files.forEach(file => formData.append("fotos", file));

                const response = await axios.post(
                    `${API_BASE_URL}/auto-sale/validate-picture`,
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                if (response.data.success) {
                    this.errors.fotos = '';

                    // Keep only the first file in the current input
                    this.selectedFiles[index] = [files[0]];
                    this.formData.fotos[index] = [files[0]];

                    console.log("✅ Successfully uploaded:", files.map(f => f.name));

                    // Push remaining files to new inputs
                    const remainingFiles = files.slice(1);
                    remainingFiles.forEach((file) => {
                        if (this.fileInputs.length < this.maxFields) {
                            this.fileInputs.push({});
                            this.selectedFiles.push([file]); // Assign each file to a new field
                            this.formData.fotos.push([file]);
                        }
                    });

                    // Ensure there is always an empty field for adding new images
                    if (this.fileInputs.length < this.maxFields && !this.selectedFiles.some(arr => arr.length === 0)) {
                        this.fileInputs.push({});
                        this.selectedFiles.push([]);
                    }

                    event.target.value = "";
                } else {
                    console.error("❌ Backend Error:", response.data.errors);
                    this.errors.fotos = response.data.errors[0]?.msg || "Validation failed.";
                    event.target.value = "";
                }
            } catch (error) {
                console.error("❌ Upload Error:", error);
                this.errors.fotos = error.response?.data?.errors?.map(err => err.msg).join(", ") || "Unknown error occurred.";
                event.target.value = "";
            }
        },

        triggerFileInput(index) {
            if (this.$refs.fileInputRefs && this.$refs.fileInputRefs[index]) {
                this.$refs.fileInputRefs[index].click();
            }
        },

        removeFileInput(index) {
            if (this.fileInputs.length > 1) {
                this.fileInputs.splice(index, 1);
                this.selectedFiles.splice(index, 1);
                this.formData.fotos.splice(index, 1);
            }

            // Ensure there's at least one empty "+" field at the end
            if (!this.selectedFiles.some(arr => arr.length === 0) && this.fileInputs.length < this.maxFields) {
                this.fileInputs.push({});
                this.selectedFiles.push([]);
            }
        },

        handleDrop(event, index) {
            event.preventDefault();
            const files = Array.from(event.dataTransfer.files);
            if (files.length > 0) {
                this.handleFileUpload({ target: { files } }, index);
            }
        },

        addFileInput() {
            this.fileInputs.push({});
            this.selectedFiles.push([]); // Maintain selectedFiles array consistency
            this.$nextTick(() => {
                this.$refs.fileInputRefs = this.$refs.fileInputRefs || [];
            });
        },
        
        async validateField(field) {
            try {
   
                
                const response = await axios.post(`${API_BASE_URL}/auto-sale/validate`, {
                    field,
                    value: this.formData[field],
                    lang: this.$i18n.locale // ✅ Pass the current language dynamically
                });



                if (response.data.success) {
                    this.errors[field] = '';  // Clear error if valid
                    return true;
                }
            } catch (error) {

                if (error.response && error.response.data.errors) {

                    this.errors[field] = error.response.data.errors[0].msg;  // Set the error message for the field

                } else {
                    console.log(error.response);
                    this.errors[field] = 'Unknown error occurred';
                }
                return false;
            }
        }
        ,
        handleCheckboxChange(event, value) {
            if (!Array.isArray(this.formData.ausstattung)) {
                this.formData.ausstattung = []; // Ensure ausstattung is an array
            }
            if (event.target.checked) {
                if (!this.formData.ausstattung.includes(value)) {
                    this.formData.ausstattung.push(value);
                }
            } else {
                this.formData.ausstattung = this.formData.ausstattung.filter(
                    (item) => item !== value
                );
            }

        },
        async handleSubmit() {
            try {
                this.errors = {}; // Reset errors before validation

                // Validate all fields except 'fotos'
                const fieldsToValidate = Object.keys(this.formData).filter(key => key !== "fotos");

                const validationResults = await Promise.all(
                    fieldsToValidate
                        .filter(field => field !== "ausstattung") // Exclude 'ausstattung' from validation
                        .map(async (field) => {
                            const isValid = await this.validateField(field);
                            return { field, isValid };
                        })
                );

                // Check if any field is invalid
                const hasErrors = validationResults.some(result => !result.isValid);
                if (hasErrors) {
                    alert("Please correct the errors before submitting.");
                    return;
                }


                // Prepare form data for submission
                const form = new FormData();

                // Append validated form fields
                fieldsToValidate.forEach((key) => {
                    if (key === "ausstattung" && Array.isArray(this.formData.ausstattung)) {
                        this.formData.ausstattung.forEach((item) => {
                            form.append("ausstattung[]", item);
                        });
                    } else {
                        form.append(key, this.formData[key] || ""); // Ensure empty fields are sent properly
                    }
                });

                // Append 'fotos' separately (if any)
                if (this.formData.fotos && Array.isArray(this.formData.fotos)) {
                    this.formData.fotos.flat().forEach((file) => {
                        form.append("fotos", file);
                    });
                }

                // Send the form data
                const response = await axios.post(
                    `${API_BASE_URL}/auto-sale/sale-submit`,
                    
                    form,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            "Accept-Language": this.$i18n.locale,
                        },
                    }
                );

                this.formData.fotos = []; // Reset photos after submission

                // Handle success

                if (response.status === 200) {
                    const locale = this.$i18n.locale;
                    sessionStorage.setItem("formSubmitted", "true");
                    this.$router.push({ name: `SuccessPage${locale.toUpperCase()}` });


                }

            } catch (error) {
                if (error.response && error.response.status === 400) {
                    // Handle validation errors from backend
                    this.errors = {};
                    error.response.data.errors.forEach((err) => {
                        this.errors[err.field] = err.msg;
                        alert(err.msg);
                    });
                } else {
                    // Handle unexpected errors
                    console.error("Unexpected Error:", error);
                    alert(
                        error.response?.data?.error || "An unexpected error occurred. Please try again."
                    );
                }
            }
        }


    },
    mounted() {
        this.$refs.fileInputRefs = []; // Ensure refs are initialized
    }
};
</script>

<style scoped>
/* Hide the default file input */
.hidden-file-input {
    display: none;
}

/* File List: Display images in a column */
.file-upload-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* Image Row */
.file-upload-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
}

/* Image Box (80% width) */
.image-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    height: 50px;
    border: 2px solid #6dc6a4;
    border-radius: 5px;
    background-color: #f5f5f5;
    color: #6dc6a4;
    font-size: 16px;
    padding: 10px;
    position: relative;
    cursor: pointer;
}

/* Centered "+" icon */
.plus-icon {
    font-size: 24px;
    font-weight: bold;
    color: #6dc6a4;
    margin: auto;
}

/* File Name */
.file-name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 10px;
}

/* Remove Button Box (20% width, aligned right) */
.remove-box {
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Remove Button */
.remove-btn {
    background-color: transparent;
    border: none;
    color: #ff5252;
    font-size: 20px;
    cursor: pointer;
}

.remove-btn:hover {
    color: white;
    background-color: red;
}

</style>
